import Route from 'rise-ui/utils/routing/route.js';

import { service } from '@ember/service';
import { hash } from 'rsvp';

import { breadcrumb } from 'rise-ui/services/breadcrumb.js';
import { scrollRoot } from 'rise-ui/services/scroll-root.js';

@scrollRoot
export default class AnnouncementsRoute extends Route {
  @service announcements;

  @breadcrumb crumb = 'Announcements';

  model() {
    return hash({
      announcements: this.announcements.fetch('announcements'),
    });
  }
}
